import authorFromScratch from "./authorFromScratch";

const exportArray = [authorFromScratch];

export default exportArray;
